module.exports = __webpack_public_path__ + "static/img/yytx36.ad240f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx36.png
// module id = 814
// module chunks = 0